import {isEmpty} from 'lodash-es';
import type {ReactElement} from 'react';
import {useState} from 'react';

import {Button} from '@/components';
import type {AfriexReferralTier} from '@/types';

import TierFormModal from './TierFormModal';

type TierUpdateButtonProps = {
  initialData?: AfriexReferralTier;
  isMerchant?: boolean;
};

const TierUpdateButton = ({
  initialData,
  isMerchant = false,
}: TierUpdateButtonProps): ReactElement => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const updateLabel = isEmpty(initialData)
    ? `Create ${isMerchant ? 'Merchant' : 'Referral'} Tier +`
    : `Update ${isMerchant ? 'Merchant' : 'Referral'} Tier`;
  const toggleFullScreen = () => {
    setShowFullScreen(!showFullScreen);
  };

  return showFullScreen ? (
    <TierFormModal
      isOpen={showFullScreen}
      onClose={toggleFullScreen}
      data={initialData}
      isMerchant={isMerchant}
    />
  ) : (
    <Button variant="solid" colorScheme="cyan" onClick={toggleFullScreen}>
      {updateLabel}
    </Button>
  );
};

export default TierUpdateButton;
